import React, {useState, Suspense, useEffect, useRef, useLayoutEffect} from 'react'
import {Canvas, useFrame, useLoader, useThree } from "@react-three/fiber";
import { OrbitControls, useTexture, Line  } from "@react-three/drei";
import * as THREE from "three";
import styles from './Orbits3D.module.scss'

function Lights() {
    return (
        <>
            <ambientLight />
            <pointLight position={[0, 0, 0]} />
        </>
    );
}

function Planet() {
    const textureProps = useTexture({
        // map: "/media/img/earth_texture.jpg"
        //map: "media/img/Nova_earth_map2.png"
        map: "media/img/Nova_earth_map3-75.png"
    });
    return (
        <mesh>
            <sphereGeometry args={[2.5, 32, 32]} />
            <meshLambertMaterial
                transparent={true}
                {...textureProps}
            // metalnessMap={metalness}
            // bumpMap={bump}
            // aoMap={ao}
            // normalMap={normal}
            // roughnessMap={rough}
            />
        </mesh>
    );
}

function rotatePoints(points, axis, angle) {
    var quat = new THREE.Quaternion();

    var axis;
    switch (axis) {// O.o it have to be a better way.
        case 'X':
            axis = new THREE.Vector3(1, 0, 0)
            break;
        case 'Y':
            axis = new THREE.Vector3(0, 1, 0)
            break;
        case 'Z':
            axis = new THREE.Vector3(0, 0, 1)
            break;
        default:
            axis = new THREE.Vector3(1, 0, 0)
            break;
    }

    quat.setFromAxisAngle(axis, angle * Math.PI / 180); // dont know why but it works T_T

    return points.map(p => {
        return p.applyQuaternion(quat);
    });
}


function Ecliptic({ offsetX, offsetY, xRadius = 1, zRadius = 1, rotateX, rotateY, rotateZ, lineColor= "#E18B00" }) {
    var points = [];

    for (let index = 0; index < 360; index++) {
        var phi = (index / 360) * Math.PI * 2;
        var x = offsetX + xRadius * Math.cos(phi);
        var z = offsetY + zRadius * Math.sin(phi);
        points.push(new THREE.Vector3(x, 0, z));
    }

    // other Way to render the line
    // const lineGeometry = new THREE.BufferGeometry().setFromPoints(points);

    if (rotateX)
        points = rotatePoints(points, 'X', rotateX);
    if (rotateY)
        points = rotatePoints(points, 'Y', rotateY);
    if (rotateZ)
        points = rotatePoints(points, 'Z', rotateZ);


    points.push(points[0]); // close the ellipses to the first point to be the last one
    return (
        <>
            <Line
                points={points}       // Array of points
                color={lineColor}                   // Default
                lineWidth={2.5}                   // In pixels (default)
            // {...lineProps}                  // All THREE.Line2 props are valid
            // {...materialProps}              // All THREE.LineMaterial props are valid
            />
            {/* The primary option to render a line, but the linewith does not work
            <line geometry={lineGeometry}>
                <lineBasicMaterial attach="material" color="#BFBBDA" linewidth={10} />
            </line> */}
        </>
    );
}

function Camera(props) {
    const ref = useRef();
    const set = useThree((state) => state.set);
    useEffect(() => {
             void set({ camera: ref.current })
    }, []);
    useFrame(() => ref.current.updateMatrixWorld());
    return <perspectiveCamera ref={ref} {...props} />;
}



const Orbits3D = props => {
    const orbitControlsRef = useRef()
    const [isFirst, setIsFirst] = React.useState(true);


    // useLayoutEffect( () => {
    //     if (orbitControlsRef.current) {
    //         const controls = orbitControlsRef.current
    //         controls.enableDamping = true;   //damping
    //         controls.dampingFactor = 0.25;   //damping inertia
    //         controls.enableZoom = false;      //Zooming
    //         controls.autoRotate = false;       // enable rotation
    //         controls.maxPolarAngle = Math.PI / 2; // Limit angle of visibility
    //         controls.keys = {
    //             LEFT: 37, //left arrow
    //             UP: 38, // up arrow
    //             RIGHT: 39, // right arrow
    //             BOTTOM: 40 // down arrow
    //         };
    //
    //
    //     }
    //
    // }, [orbitControlsRef.current])


    // setInterval( () => {
    //     orbitControlsRef.current.reset();
    // }, 5000)



    const orbits = props.orbits || [];
    if (!props?.camera) return null;
    return (
        <div className={styles.Canvas}><Canvas
            style={{
                display: `block`,
                width: 500,
                height: 500
            }}
            // camera={{
            //     position: [0, 90, 0],
            //     fov: props.camera }
            // }
            >
            <Suspense fallback={null}>
                <Camera
                    position={[0, 5,  props.camera] }
                    fov={35}
                    orbitsControlRef={orbitControlsRef}
                />
                <Planet />
                {orbits.map((o, i) =>
                    <Ecliptic
                        key={i}
                        lineColor={props.orbitColor}
                        {...o}
                    // xRadius={10}
                    // zRadius={10}
                    // offsetX={0}
                    // offsetY={0}
                    // rotateX={0}
                    // rotateY={0}
                    // rotateZ={0}
                    />
                )}

                <Lights />
                <OrbitControls ref={orbitControlsRef} />
            </Suspense>
        </Canvas></div>
    );
}



export default Orbits3D;
